import styled from '@emotion/styled';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { AccountContent } from 'src/domains/players/webview/components/Account/accountParts/Account.style';
import { withConfig } from 'src/withConfig';

export const DepositTabWrapper = withConfig(theme => styled(AccountContent, { label: 'DepositTabWrapper' })<{ isSignup?: boolean }>`
    color: ${({ isSignup }): string => (isSignup === true ? theme.star.signUp.txtColor : theme.star.topUp.txtColor)};
    overflow-y: ${({ isSignup }): string => (isSignup === true ? 'visible' : 'auto')};
    padding: ${({ isSignup }): string => (isSignup === true ? '0 16px 16px 16px' : '16px')};
`);

export const ApplePayBannerWrapper = withConfig(theme => styled('div', { label: 'ApplePayBannerWrapper' })`
    padding: ${theme.star.padding.large};
    display: flex;
    flex-flow: row nowrap;
    gap: 16px;
    background: ${theme.star.depositPaymentMethods.bgColorSecondary};
    align-items: center;
`);
export const ApplePayBannerText = styled('div', { label: 'ApplePayBannerText' })`
    display: flex;
    flex-flow: column nowrap;
    gap: 4px;
`;

export const ApplePayBannerTitle = withConfig(theme => styled('span', { label: 'ApplePayBannerTitle' })`
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.33;
    color: ${theme.star.depositPaymentMethods.txtColor};
`);

export const ApplePayBannerDescription = withConfig(theme => styled('span', { label: 'ApplePayBannerDescription' })`
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.2;
    color: ${theme.star.depositPaymentMethods.txtColorSecondary};
`);

export const CashBalanceWrapper = withConfig(theme => styled('div', { label: 'CashBalanceWrapper' })`
    color: currentcolor;
    display: flex;
    font-size: ${theme.star.fontSize.small};
    justify-content: space-between;
    align-items: center;
`);

export const CashBalance = withConfig(theme => styled('span', { label: 'CashBalance' })`
    font-weight: ${theme.star.fontWeight.bold};
    font-size: ${theme.star.fontSize.xRegular};
`);

export const CardInfo = withConfig(theme => styled('p', { label: 'CardInfo' })`
    color: currentcolor;
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
    margin: 8px 0 22px;
    text-align: center;
`);

export const DepositInputLabel = withConfig(theme => styled(I18n, { label: 'DepositInputLabel' })`
    font-weight: ${theme.star.fontWeight.bold};
`);

export const DepositContainer = styled('div', { label: 'DepositContainer' })`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
`;

